import { render } from "./DiscountItem.vue?vue&type=template&id=62e87cf7"
import script from "./DiscountItem.vue?vue&type=script&lang=js"
export * from "./DiscountItem.vue?vue&type=script&lang=js"

import "./DiscountItem.vue?vue&type=style&index=0&id=62e87cf7&lang=css"
script.render = render

export default script